let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("U3lMW")).then(() => parcelRequire('cU5Kj'));